import React, { useState } from "react";
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
function formatDate(date) {
    // Array of weekday names
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Extract date components
    const weekday = weekdays[date.getDay()]; // Get the weekday name
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month and pad single digit months
    const day = String(date.getDate()).padStart(2, '0'); // Get day and pad single digit days
    const year = date.getFullYear(); // Get the year

    // Return formatted string
    return `${weekday} ${month}/${day}/${year}\n`;
}
function Engineering({setLoading}) {
    const [description, setDescription] = useState("");
    const [selectedDate, setSelectedDate] = useState(new Date());
    const googleDoc = () => {
        window.open('https://docs.google.com/document/d/1O-OVNg1xESE66g6ozhKTPDya1Ad95IpmnaVJZ8SGNuA/edit', "_blank")

    }
    const handleSubmit = async () => {
        setLoading(true)
        const data = {
            log: description,
            action: "add_entry",
            key: process.env.REACT_APP_customApiKey,
            date: formatDate(selectedDate)
        }
        const URL = process.env.REACT_APP_API_URL + '/api'
        try {
            await axios.post(URL, data);
            setDescription("")
            //res.data.link is the doc link fucking finally
        } catch (error) {
            console.error('Error:', error);
        }
        setLoading(true)


    };
    return <div className="shadow-lg rounded-sm w-full p-3 min-w-min">
        <h1 className="text-xl md:text-3xl text-black font-bold pb-3">Engineering Notebook</h1>
        <div className="flex flex-col gap-1 text-left" >
            <DatePicker
                selected={selectedDate}
                onChange={date => setSelectedDate(date)}
                dateFormat="MMMM d, yyyy"
                todayButton="Today"
                className="inline-block p-3 mt-2 mb-4 w-fit border border-primary rounded-md shadow-sm focus:outline-none focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
            />
            <p className="text-black text-base md:text-xl font-light my-2">Accomplishments</p>
            <textarea className="p-2 text-red-500 text-sm md:text-base " value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>

        <p className="text-red-500  cursor-pointer text-sm md:text-base underline mt-2" onClick={googleDoc}>Engineering Notebook</p>

        <button onClick={handleSubmit} className="outline outline-red-500 text-sm md:text-base outline-2 bg-red-500 text-white duration-300 hover:bg-white hover:text-red-500 p-2 rounded-lg mt-4 ">Add Entry</button>
    </div>
}
export default Engineering;